import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';

import { showToast } from '@app/providers/ToastProvider';

import { isRetrievalOnly } from '@utils/environment';

import configRequest from '../configRequest';
import AUTH_FORM_RESET_PASSWORD_TYPES_ENUM from '../authForms/enums/AUTH_FORM_RESET_PASSWORD_TYPES_ENUM.enum';

export interface ResetPasswordData {
	auth_form_slug: string;
	code: string;
	contact: string;
	new_password: string;
	reset_type: AUTH_FORM_RESET_PASSWORD_TYPES_ENUM;
}

export type ResetPasswordResponse = void;

const resetPassword = configRequest<ResetPasswordResponse, ResetPasswordData>({
	requestPrefix: 'auth/reset-password',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH.RESET_PASSWORD(),
		method: HTTP_METHODS_ENUM.PUT,
		data: data as ResetPasswordData,
	}),
	onSuccess: () =>
		showToast.success(
			isRetrievalOnly() ? 'Password has been created successfully.' : 'Password has been reset successfully.',
		),
});

export default resetPassword;
